import { useState, useEffect } from "react";
import { Shield } from "lucide-react";

const CONSENT_KEY = "enthida_cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === "accepted") {
      // User already accepted - load GA4
      if (window.loadGA4) window.loadGA4();
    } else if (consent !== "declined") {
      // No decision yet - show banner
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    if (window.loadGA4) window.loadGA4();
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[90] p-4 print:hidden"
      data-testid="cookie-banner"
    >
      <div className="max-w-2xl mx-auto bg-[#0f1115] border border-white/10 rounded-2xl p-5 shadow-[0_-4px_40px_rgba(0,0,0,0.5)] backdrop-blur-xl">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-[#a3e635]/20 to-[#22d3ee]/20 rounded-lg mt-0.5">
            <Shield className="w-5 h-5 text-[#a3e635]" />
          </div>
          <div>
            <h4 className="text-white text-sm font-bold mb-1">Cookie-Einstellungen</h4>
            <p className="text-slate-400 text-xs leading-relaxed">
              Wir verwenden Cookies zur Analyse und Verbesserung unserer Website (Google Analytics). 
              Ihre Daten werden anonymisiert verarbeitet. 
              <a href="/datenschutz" className="text-[#22d3ee] hover:underline ml-1">Mehr erfahren</a>
            </p>
          </div>
        </div>
        <div className="flex gap-3 justify-end">
          <button
            onClick={decline}
            className="px-4 py-2 text-xs font-medium text-slate-400 border border-white/10 rounded-full hover:border-white/30 transition-colors cursor-pointer"
            data-testid="cookie-decline-btn"
          >
            Ablehnen
          </button>
          <button
            onClick={accept}
            className="px-5 py-2 text-xs font-semibold text-black bg-gradient-to-r from-[#a3e635] to-[#22d3ee] rounded-full hover:scale-[1.02] transition-transform cursor-pointer"
            data-testid="cookie-accept-btn"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
